import ChatImageMessageBox from "./ChatImageMessageBox";
export default ChatImageMessageBox;
